export const YM_ID = 61897962;
let _loaded = false;

export function initYandexMetrika() {
  if (_loaded) return;
  _loaded = true;
  const w = window;
  const d = document;
  const tag = "script";
  const src = "https://mc.yandex.ru/metrika/tag.js";
  const id = "ym";
  w[id] =
    w[id] ||
    function () {
      (w[id].a = w[id].a || []).push(arguments);
    };
  w[id].l = Date.now();
  const k = d.createElement(tag);
  const a = d.getElementsByTagName(tag)[0];
  k.async = true;
  k.src = src;
  a.parentNode.insertBefore(k, a);
  w[id](YM_ID, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });
}

export function getCookieConsent() {
  try {
    return JSON.parse(localStorage.getItem("kolodec_cookie_consent"));
  } catch {
    return null;
  }
}

export function setCookieConsent(data) {
  localStorage.setItem(
    "kolodec_cookie_consent",
    JSON.stringify({
      ...data,
      timestamp: Date.now(),
    })
  );
}
